import * as React from 'react';
import * as ReqType from '../../../types/ServerRequests';

/*export interface Course {
    id: number;
    Disciplines: string;
    Jours: string;
    Horraires: string;
    Lieux: string;
}*/

interface Props {
    disabled?: boolean;
    course: ReqType.Course;
    add?: (coursesChosen: number) => void;
    checked: boolean;
}

interface State {
}

/**
 * Ce composant permet l'affichage du fomulaire d'adhesion partie2 avec les cours
 */
export class Adhere2CourseLine extends React.Component {
    state: State;
    props: Props;

    constructor(props: Props) {
        super(props);
    }

    chooseCourse = () => {
        if (this.props.add !== undefined) {
            this.props.add(this.props.course.id);
        }
    }

    render() {
        return (
            <tr key={this.props.course.id}>
                <td>{this.props.course.discipline.intitule}</td>
                <td>{this.props.course.jour}</td>
                <td>{this.props.course.horaire}</td>
                <td>{this.props.course.adresse}</td>
                <td>
                    <input
                        className="form-check-input col-md-1"
                        type="checkbox"
                        id="inlineCheckbox3"
                        disabled={this.props.disabled}
                        onClick={this.chooseCourse}
                        checked={this.props.checked}
                    />
                </td>
            </tr>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/MembershipPage/internalComponents/Adhere2CourseLine.tsx